import React, { useContext } from 'react';

type Theme = unknown;

const context = React.createContext<Theme | null>(null);
const ThemeProvider = context.Provider;
const useTheme = () => useContext(context);

export { ThemeProvider, useTheme };
